import Resource from '@/api/resources/Resource'

class SampleProcessingSampleService extends Resource {
    async sampleSectionsSummary(laboratoryId, caseId, sampleId) {
        return this.axios.get(`/sampleProcessing/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/sectionsSummary`).then(response => response.data)
    }

    async findById(labId, casId, samId) {
        return this.axios.get(`/sampleProcessing/laboratories/${labId}/cases/${casId}/samples/${samId}`).then(response => response.data)
    }

    async searchSampleBySampleLabel(labId, sampleLabel) {
        let params = { sampleLabel }
        const response = await this.axios.get(`/sampleProcessing/laboratories/${labId}/samples/searchByLabel`, { params })
        return response.data
    }

    async updateSample(labId, casId, sampleId, sample) {
        let response = await this.axios.patch(`/sampleProcessing/laboratories/${labId}/cases/samples/`, sample)
        return response.data
    }

    async updateSampleFields(labId, casId, sampleId, sample) {
        const response = await this.axios.put(`/sampleProcessing/laboratories/${labId}/cases/samples/fields`, sample)
        return response.data
    }

    async process(labId, casId, sampleId) {
        return this.axios.put(`/sampleProcessing/laboratories/${labId}/cases/${casId}/samples/${sampleId}/process`)
    }

    async launchAutomatismsAndUpdateSample(labId, casId, sampleId, cancelPreviousAutomatisms, shouldAddPreformattedInsteadOfReplacing, applyTotalReplace, shouldCheckThatSectionsCanBeAdded, sample) {
        let params = { cancelPreviousAutomatisms, shouldAddPreformattedInsteadOfReplacing, applyTotalReplace, shouldCheckThatSectionsCanBeAdded }
        const response = await this.axios.patch(`/sampleProcessing/laboratories/${labId}/cases/samples/launchAutomatismsAndPatchSample`,
            sample,
            { params })
        return response.data
    }

    async cancelAutomatismsAndUpdateSample(labId, casId, sampleId, sample) {
        const response = await this.axios.patch(`/sampleProcessing/laboratories/${labId}/cases/samples/cancelAutomatismsAndPatchSample`, sample)
        return response.data
    }

    async createSubsampleBatch(labId, caseId, samples) {
        return this.axios.post(`/sampleProcessing/laboratories/${labId}/cases/${caseId}/subsamples/batch`, samples)
    }

    async deleteSample(labId, casId, sampleId) {
        return this.axios.delete(`/sampleProcessing/laboratories/${labId}/cases/${casId}/samples/${sampleId}`)
    }

    async updateBatch(labId, requests) {
        return this.axios.patch(`/sampleProcessing/laboratories/${labId}/cases/samples/patchBatch`, requests)
    }
}

export default new SampleProcessingSampleService()
